import React, { createContext, useContext, useState, ReactNode } from 'react';

interface DeploymentTrackerContextType {
  deploymentId: string | null;
  isMonitoring: boolean;
  startMonitoring: (id: string) => void;
  stopMonitoring: () => void;
}

const DeploymentTrackerContext = createContext<DeploymentTrackerContextType | undefined>(undefined);

interface DeploymentTrackerProviderProps {
  children: ReactNode;
}

export const DeploymentTrackerProvider: React.FC<DeploymentTrackerProviderProps> = ({ children }) => {
  const [deploymentId, setDeploymentId] = useState<string | null>(null);
  const [isMonitoring, setIsMonitoring] = useState<boolean>(false);

  const startMonitoring = (id: string) => {
    setDeploymentId(id);
    setIsMonitoring(true);
  };

  const stopMonitoring = () => {
    setIsMonitoring(false);
  };

  const value = {
    deploymentId,
    isMonitoring,
    startMonitoring,
    stopMonitoring
  };

  return (
    <DeploymentTrackerContext.Provider value={value}>
      {children}
    </DeploymentTrackerContext.Provider>
  );
};

export const useDeploymentTracker = (): DeploymentTrackerContextType => {
  const context = useContext(DeploymentTrackerContext);
  if (context === undefined) {
    throw new Error('useDeploymentTracker must be used within a DeploymentTrackerProvider');
  }
  return context;
};